import React from "react";
import "./SaaSUIToolkit.css";

export const SaaSLoadingSkeleton = ({
  type = "card",
  count = 3,
}) => {
  if (type === "stats") {
    return (
      <div className="row g-3 mb-4">
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="col-12 col-sm-6 col-lg-3">
            <div className="saas-stat-card">
              <div className="saas-skeleton" style={{ width: 48, height: 48, borderRadius: 10 }} />
              <div style={{ flex: 1 }}>
                <div className="saas-skeleton mb-2" style={{ height: 14, width: "60%" }} />
                <div className="saas-skeleton" style={{ height: 28, width: "40%" }} />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (type === "list") {
    return (
      <div className="d-flex flex-column gap-3">
        {Array.from({ length: count }).map((_, i) => (
          <div
            key={i}
            className="saas-card p-3 d-flex align-items-center gap-3"
          >
            <div
              className="saas-skeleton"
              style={{ width: 64, height: 64, borderRadius: 8, flexShrink: 0 }}
            />
            <div style={{ flex: 1 }}>
              <div className="saas-skeleton mb-2" style={{ height: 18, width: "50%" }} />
              <div className="saas-skeleton mb-2" style={{ height: 14, width: "70%" }} />
              <div className="saas-skeleton" style={{ height: 12, width: "30%" }} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="row g-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="col-12 col-md-6 col-lg-4">
          <div className="saas-card overflow-hidden">
            <div className="saas-skeleton" style={{ height: 160, width: "100%" }} />
            <div className="p-3">
              <div className="saas-skeleton mb-2" style={{ height: 18, width: "75%" }} />
              <div className="saas-skeleton mb-2" style={{ height: 14, width: "50%" }} />
              <div className="saas-skeleton" style={{ height: 14, width: "35%" }} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SaaSLoadingSkeleton;
